import { initRedirectToCheckout } from '../../../../../Common/Resources/src_front/js/components/initRedirectToCheckout';

initRedirectToCheckout();
